// extracted by mini-css-extract-plugin
module.exports = {"columns-3":"1700","columns-2":"1550","columns-1":"1350","grayTableHeader":"GrayTableHeader_grayTableHeader__3Irfm","grayTableCell":"GrayTableHeader_grayTableCell__g44Lh"};